import { createContext, useContext, useMemo } from 'react';
import type { ReactNode } from 'react';
import { useLoaderData } from 'react-router-dom';

export interface TenantState {
  id: string;
  slug: string;
  name: string;
  status: string;
}

const TenantContext = createContext<TenantState | null>(null);

export function TenantProvider({ children }: { children: ReactNode }): JSX.Element {
  const tenant = useLoaderData() as TenantState;
  const value = useMemo(() => tenant, [tenant]);
  return <TenantContext.Provider value={value}>{children}</TenantContext.Provider>;
}

export function useTenant(): TenantState {
  const tenant = useContext(TenantContext);
  if (!tenant) throw new Error('useTenant must be used inside TenantProvider');
  return tenant;
}
